import React from 'react';
import { ServiceType } from '../../../../services/ConfigurationService/types/serviceType';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useUpsertServiceMutation } from '../../../../services/ConfigurationService';

export function EditServiceDialog({ service, onCancel, onSuccess }: {
  service: ServiceType;
  onCancel: () => void;
  onSuccess?: () => void;
}) {
  const [code, setCode] = React.useState(service.code);
  const [description, setDescription] = React.useState(service.description);
  const [upsertService, { isLoading }] = useUpsertServiceMutation();

  const handleSave = async () => {
    const id = `${service.centerId}-${code}`;
    await upsertService({ ...service, code, description, id });
    if (onSuccess) onSuccess();
    onCancel();
  };

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Service</DialogTitle>
      <DialogContent>
        <TextField
          label="Code"
          value={code}
          onChange={e => setCode(e.target.value)}
          fullWidth
          margin="normal"
          disabled
        />
        <TextField
          label="Description"
          value={description}
          onChange={e => setDescription(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={isLoading}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}


